module.exports = __webpack_public_path__ + "img/火星.555e295c.svg";